async function checkDownloadAvailabilityAndGetUrl({ itemId, destinationUrl }) {
  if (!itemId || !destinationUrl) {
    return { status: 'error' }
  }

  const successResponse = {
    status: 'ok',
    downloadUrl: destinationUrl,
  }

  try {
    const response = await fetch(`/items/${itemId}/can-download-item-files`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    })

    if (response.status === 403) {
      return { status: 'limit_reached' }
    }

    return successResponse
  } catch {
    return successResponse
  }
}

export default checkDownloadAvailabilityAndGetUrl
